import React, { useEffect, useState } from 'react';
import styled from 'astroturf/react';

import { trackClick } from 'js/utils/trackClick';

import { useBreakpoint } from 'js/design_system/hooks/useBreakpoint';
import { Icon } from 'js/design_system/Icon';
import { Body } from 'js/design_system/Body';
import _Container from "StickyWorkCardHeader-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/single_work/loswp/StickyWorkCardHeader.tsx?styleId=Container";
import _TitleRow from "StickyWorkCardHeader-TitleRow.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/single_work/loswp/StickyWorkCardHeader.tsx?styleId=TitleRow";
import _Title from "StickyWorkCardHeader-Title.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/single_work/loswp/StickyWorkCardHeader.tsx?styleId=Title";
import _InfoBadge from "StickyWorkCardHeader-InfoBadge.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/single_work/loswp/StickyWorkCardHeader.tsx?styleId=InfoBadge";
import _InfoBadgeText from "StickyWorkCardHeader-InfoBadgeText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/single_work/loswp/StickyWorkCardHeader.tsx?styleId=InfoBadgeText";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const TitleRow = /*#__PURE__*/styled("div", null, {
  displayName: "TitleRow",
  styles: _TitleRow
});

const Title = /*#__PURE__*/styled("div", null, {
  displayName: "Title",
  styles: _Title
});

const InfoBadge = /*#__PURE__*/styled("button", null, {
  displayName: "InfoBadge",
  styles: _InfoBadge
});

const InfoBadgeText = /*#__PURE__*/styled(Body, null, {
  displayName: "InfoBadgeText",
  styles: _InfoBadgeText
});

interface Props {
  workTitle: string;
  workId: number;
  designVariant: string;
}

export const StickyWorkCardHeader: React.FC<Props> = ({
  workTitle,
  workId,
  designVariant,
}) => {
  const [hasScrolledPastDocumentTop, setHasScrolledPastDocumentTop] =
    useState(false);
  const [isDocumentBottomInView, setIsDocumentBottomInView] = useState(false);
  const breakpoint = useBreakpoint();
  const isDesktop = breakpoint === 'large';

  // Show header once the top of the viewport has passed the top of the document;
  // hide when the bottom of the document is in view
  useEffect(() => {
    const embeddedDocument = document.querySelector(
      '.js-loswp-embedded-document',
    ) as HTMLElement;
    if (!embeddedDocument) return;

    const checkDocumentPosition = () => {
      const rect = embeddedDocument.getBoundingClientRect();
      setHasScrolledPastDocumentTop(rect.top <= 0);
      setIsDocumentBottomInView(rect.bottom <= window.innerHeight);
    };

    window.addEventListener('scroll', checkDocumentPosition);
    checkDocumentPosition();

    return () => window.removeEventListener('scroll', checkDocumentPosition);
  }, []);

  const handleInfoBadgeClick = () => {
    trackClick({
      source: 'loswp--info-badge--sticky-header',
      bucket: designVariant,
      entityId: workId,
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Expand all content controlled by the info badge (metadata + content sections)
    const workCardInfoBadge = document.querySelector(
      '.js-info-badge-toggle',
    ) as HTMLButtonElement;
    const collapsibles = document.querySelectorAll<HTMLElement>(
      '.js-info-badge-collapsible',
    );

    if (workCardInfoBadge) {
      workCardInfoBadge.setAttribute('aria-expanded', 'true');
    }
    collapsibles.forEach((el) => {
      el.setAttribute('aria-hidden', 'false');
      el.classList.add('expanded');
    });
  };

  const shouldShow =
    hasScrolledPastDocumentTop && !isDesktop && !isDocumentBottomInView;

  return (
    <Container className={shouldShow ? '' : 'hidden'} aria-hidden="true">
      <TitleRow>
        <Title>{workTitle}</Title>
        <InfoBadge
          type="button"
          aria-label="Scroll to work details"
          onClick={handleInfoBadgeClick}
        >
          <Icon name="info" size={16} />
          <InfoBadgeText size="sm">Info</InfoBadgeText>
          <Icon name="keyboard_arrow_up" size={16} />
        </InfoBadge>
      </TitleRow>
    </Container>
  );
};

export default StickyWorkCardHeader;
